import { render } from "./AboutUsedCar.vue?vue&type=template&id=2dc8b747&scoped=true"
import script from "./AboutUsedCar.vue?vue&type=script&lang=js"
export * from "./AboutUsedCar.vue?vue&type=script&lang=js"

import "./AboutUsedCar.vue?vue&type=style&index=0&id=2dc8b747&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc8b747"]])

export default __exports__